import FileNode from "./FileNode";
import InputNode from "./InputNode";
import DateNode from "./DateNode";
import DateTimeNode from "./DateTimeNode";
import Textarea from "./Textarea";
import SelectNode from "./SelectNode";
import CheckboxNode from "./CheckboxNode";
import SwitchNode from "./SwitchNode";
import CheckboxGroupNode from "./CheckboxGroupNode";
import RadioNode from "./RadioNode";
import RangeNode from "./RangeNode";
import RadioGroupNode from "./RadioGroupNode";
import BoxRadioGroupNode from "./BoxRadioGroupNode";
import InputAdornment from "@mui/material/InputAdornment";

import FormNode from "./FormNode";
import FormEffectNode from "./FormEffectNode";


export const nodeRegistry: any = {
    adornment:InputAdornment,
    box_group: BoxRadioGroupNode,
    box_radio_group: BoxRadioGroupNode,
    box_checkbox_group: BoxRadioGroupNode,
    form: FormNode,
    form_effect: FormEffectNode,
    input: InputNode,
    date: DateNode,
    datetime: DateTimeNode,
    textarea: Textarea,
    select: SelectNode,
    file: FileNode,
    switch: SwitchNode,
    range: RangeNode,
    checkbox: CheckboxNode,
    checkbox_group: CheckboxGroupNode,
    radio: RadioNode,
    radio_group: RadioGroupNode,
};

export default nodeRegistry;
